module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile"
  }, [_c('el-row', {
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12
    }
  }, [_c('div', {
    staticClass: "info-panel"
  }, [_c('div', {
    staticClass: "panelheader"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Personal Information")])]), _vm._v(" "), _c('div', {
    staticClass: "data"
  }, [_c('div', {
    staticClass: "user-info"
  }, [_c('el-row', {
    attrs: {
      "gutter": 40
    }
  }, [_c('el-col', {
    staticClass: "label",
    attrs: {
      "span": 12
    }
  }, [_c('strong', [_vm._v("Username")])]), _vm._v(" "), _c('el-col', {
    staticClass: "info",
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.user.username))])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 40
    }
  }, [_c('el-col', {
    staticClass: "label",
    attrs: {
      "span": 12
    }
  }, [_c('strong', [_vm._v("Email")])]), _vm._v(" "), _c('el-col', {
    staticClass: "info",
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.user.email))])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 40
    }
  }, [_c('el-col', {
    staticClass: "label",
    attrs: {
      "span": 12
    }
  }, [_c('strong', [_vm._v("Name")])]), _vm._v(" "), _c('el-col', {
    staticClass: "info",
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.user.name))])], 1)], 1)])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12
    }
  }, [_c('changepassword', {
    on: {
      "success": _vm.onSuccess
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dededdd2","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile.vue
// module id = 964
// module chunks = 14